export default __webpack_public_path__ + "f6ab3e7bb23a3be810f74a65078b404f.png";